import { useEffect, useState } from "react";
import { loadImage } from "../assets/loadImage";
import "./LazyImg.css";

export default function LazyImg({ imageKey, alt = "", style = {}, className = "", isBackgroundFilled = false }) {
	const [src, setSrc] = useState(null);
	const [isLoaded, setIsLoaded] = useState(false);

	useEffect(() => {
		let cancelled = false;
		setSrc(null);
		setIsLoaded(false);

		loadImage(imageKey)
			.then((resolved) => {
				if (!cancelled) setSrc(resolved);
			})
			.catch(console.error);

		return () => {
			cancelled = true;
		};
	}, [imageKey]);

	const imgClassName = [
		"lazyimg-img",
		isLoaded && "lazyimg-img--visible",
		isBackgroundFilled && "noise-window",
		className,
	].filter(Boolean).join(" ");

	return (
		<div className="lazyimg-wrap" style={style}>
			<div className={`lazyimg-skeleton${isLoaded ? " lazyimg-skeleton--hidden" : ""}`} aria-hidden="true" />

			{src && (
				<img
					src={src}
					alt={alt}
					loading="lazy"
					decoding="async"
					onLoad={() => setIsLoaded(true)}
					style={style}
					className={imgClassName}
				/>
			)}
		</div>
	);
}
